import { Observer } from 'mobx-react-lite'

import VisitCardsExpansion from 'singletons/VisitCardsExpansion'
import VisitCardHeader from './VisitCardHeader'
import VisitDetails from './VisitDetails'

type VisitCardProps = {
  // TODO - improve visit type
  visit: any
  parentVisit?: any
  memberMode?: boolean
  editable?: boolean
  providerMode?: boolean
}

const VisitCard = ({ visit, parentVisit, editable, memberMode, providerMode }: VisitCardProps) => {
  if (!visit) {
    return null
  }

  return (
    <div className="bg-white rounded-2xl shadow-[0px_8px_16px_0px_rgba(27,99,162,0.08)] p-4 flex flex-col gap-6">
      <VisitCardHeader visit={visit} memberMode={memberMode} />
      <Observer>
        {() => {
          const expanded = VisitCardsExpansion.expanded(visit.pendingVisitId)
          return expanded ? (
            <VisitDetails
              visit={visit}
              parentVisit={parentVisit}
              editable={editable}
              memberMode={memberMode}
              providerMode={providerMode}
            />
          ) : null
        }}
      </Observer>
    </div>
  )
}

export default VisitCard
